import React, { useContext } from "react";
import { RootContext } from "../../contexts/root-context.js";
import ConfigureSLD from "./configure-sld.js";
import WNTNavBar from '../../components/Wide-Area-Network-Twin-Components/WNT-Navbar/wnt-navbar.js';
import Navbar from '../../components/Navbar/navbar.js';
import PageInfoDialog from "../../components/PageInfoDialog/PageInfoDialog";
import { PAGE_INFO_DATA } from "../../utils/pageInfoData";

function WNTDashboard() {
  const { showConfigureSLDPage } = useContext(RootContext);
  return (
    <>
      {/* Page Info Icon - Fixed Position Top Right */}
      <PageInfoDialog pageData={PAGE_INFO_DATA['wnt']} pageKey="wnt" />
      
      <Navbar />
      {showConfigureSLDPage ? <ConfigureSLD /> : <WNTNavBar />}
    </>
  );
}

export default WNTDashboard;
